import { render, staticRenderFns } from "./PlacePreview.vue?vue&type=template&id=7b9c3648&scoped=true"
import script from "./PlacePreview.vue?vue&type=script&lang=ts"
export * from "./PlacePreview.vue?vue&type=script&lang=ts"
import style0 from "./PlacePreview.vue?vue&type=style&index=0&id=7b9c3648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9c3648",
  null
  
)

export default component.exports